import { get } from '../../../utils/utils';
import { toItem } from '../mappers/item';
export function getCursor(linkHeader) {
  if (!linkHeader) {
    return null;
  }
  const split = linkHeader.split(/,\s+/);
  const nextLink = split.filter(str => str.indexOf('rel="next"') > -1)[0];
  if (!nextLink) {
    return null;
  }
  const match = nextLink.match(/[?&]page=(\d+)/);
  if (!match || !match[1]) {
    return null;
  }
  return parseInt(match[1], 10);
}
export function parseItems(res) {
  const cursor = getCursor(get(res, 'data.headers.link', null));
  res.data = (res.data.result || []).map(toItem);
  res.paging = {
    cursor
  };
  return res;
}